<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';

  let error = null;

  // The Help Center is sidebar-driven. Landing on /help sends the reader
  // straight into the Getting Started section (its first doc).
  onMount(async () => {
    try {
      const res = await fetch('/content/help-manifest.json');
      if (!res.ok) throw new Error('Could not load help content.');
      const manifest = await res.json();
      const cats = Object.entries(manifest.categories)
        .map(([name, data]) => ({ name, files: data.files || [], position: data.position ?? 999 }))
        .sort((a, b) => a.position - b.position);

      const preferred = cats.find((c) => c.name === 'getting-started' && c.files.length)
        || cats.find((c) => c.files.length);
      if (!preferred) throw new Error('No help articles found.');
      const first = preferred.files.slice().sort((a, b) => a.position - b.position)[0];
      navigate(`/help/${preferred.name}/${first.slug}`, { replace: true });
    } catch (e) {
      console.error('Error loading help manifest:', e);
      error = e.message || 'Could not open the Help Center.';
    }
  });
</script>

<div class="min-h-screen bg-gray-50 flex items-center justify-center">
  <div class="text-center">
    {#if error}
      <p class="text-red-600 mb-4">{error}</p>
      <a href="/dashboard" class="text-blue-600 hover:text-blue-800 font-medium">Back to App</a>
    {:else}
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      <p class="mt-3 text-gray-600">Opening the Help Center…</p>
    {/if}
  </div>
</div>
